<template>
	<div class="flex flex-col min-h-screen" style="background-color: #f3f4f6">
		<NuxtRouteAnnouncer />
		<main class="flex-grow w-full">
			<!-- Content is centered by the container class in individual pages or wrapped here if strictly enforced globally -->
			<!-- User requested "Header Full Screen, Content Centered". AppHeader handles its own container. -->
			<!-- We allow pages to define their own containers, but for default layout we can enforce a wrapper if needed. -->
			<!-- However, many modern layouts allow full width sections in main. -->
			<!-- Based on "Content area centered", we will wrap slot in a container but allow pages to opt-out if they use a different layout. -->
			<slot />
		</main>
	</div>
</template>

<script setup lang="ts">
// Components are auto-imported by Nuxt if in components/ dir
</script>

<style scoped>
/* Scoped styles removed in favor of Tailwind classes */
</style>
